import { Download, Info, Visibility } from "@mui/icons-material";
import { Card, IconButton, Tooltip, Menu, Icon, Button,  Dialog,
  DialogContent,
  DialogTitle, Typography, Grid } from "@mui/material";
  import FormField from "layouts/pages/account/components/FormField";
import Autocomplete from "@mui/material/Autocomplete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import NotificationItem from "examples/Items/NotificationItem";
import MDButton from "components/MDButton";
import ApiCalls from "services/flick_erp_api_call";
import { useNavigate } from "react-router-dom";
import {FormControlLabel, Checkbox} from "@mui/material";
import colors from "assets/theme/base/colors";
import { authFetch } from "services";
import { base_url } from "services";

import { useTheme } from "@mui/material/styles";
import rgba from "assets/theme/functions/rgba";
import { useMaterialUIController } from "context";

export function Batch(modulePermissions, permissions) {
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const palette = theme.palette;
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [showActionMenu, setShowActionMenu] = useState(false);
  const [rowData, setRowData] = useState({});
  const [generateSalaryDialog, setGenerateSalaryDialog] = useState(false);
  const [generateSalaryData, setGenerateSalaryData] = useState({
    month : "",
    year : "",
    contract_ids : [],
    dry_run : false
  });
  const [employeeList, setEmployeeList] = useState([]);
  const dialogPaperSx = {
    backgroundColor: darkMode ? palette.background.card : colors.white.main,
    boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
    width: "50%",
    maxWidth: "none",
    borderRadius: "20px",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${darkMode ? rgba(palette.white.main, 0.08) : rgba(colors.secondary.main, 0.14)}`,
  };

  useEffect(() => {
     getEmployeeList();
  },[])

  async function getEmployeeList() {
    var res = await ApiCalls.getBaseEmployeesList("?status=active");
    if (res.success && res.code === 200) {
      // var data = JSON.parse(JSON.stringify(res.data));
      setEmployeeList(res.data)
    } else {
    }
  }
	  const [batch, setBatch] = useState({
	    columns: [
      {
        Header: "BATCH",
        accessor: "batch",
      },
	      {
	        Header: "Year",
	        accessor: "year",
	      },
	      {
	        Header: "Status",
	        accessor: "status",
	        Cell: ({ row }) => (
	          <MDBox
	            px={1.5}
	            py={0.5}
	            borderRadius="xl"
	            bgColor={row.original.is_published ? "success" : "warning"}
	            display="inline-block"
	          >
	            <MDTypography variant="caption" color="white" fontWeight="bold">
	              {row.original.is_published ? "Published" : "Draft"}
	            </MDTypography>
	          </MDBox>
	        ),
	      },
	      {
	        Header: "Action",
	        accessor: "inout",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="View Batch">
              <IconButton
                aria-label="info"
                size="small"
                onClick={(e) => handleViewClick(e, row)}
              >
                <Visibility />
              </IconButton>
            </Tooltip>
            <Tooltip title="Info">
              <IconButton
                aria-label="info"
                size="small"
                onClick={(e) => handleOpenMenuItems(e, row)}
              >
                <Info />
              </IconButton>
            </Tooltip>
            
            {/* <MDButton color="dark" size="small" onClick={(e) => handleViewClick(e, row)}>
              View
            </MDButton> */}
          </div>
        ),
      },
    ],
    rows: [],
  });

  const monthToNumber = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };

  // const handleViewClick = (e, row) => {
  //   console.log("handleViewClick",e, row);
  //   navigate("/Payrole/payroleBatches");
  // };

  const handleViewClick = (e, row) => {
    navigate("/payroll/payrollBatches", {
      state: { batchData: row.original, permissions : permissions, modulePermissions : modulePermissions  },
    });
  };

  const handleOpenMenuItems = (event, row) => {
    setRowData(row);
    setShowActionMenu(event.currentTarget);
  };

  useEffect(() => {
    getSalaryBatches();
  }, []);

  const handleCloseMenuItems = () => setShowActionMenu(false);

  const domain = "https://www.flickhr.com";

  const handlePFSheetDownload = async(month, year) => {
    try {
    const res = await authFetch(
      `${base_url}api/v1/payrole/pf-submission.xlsx?month=${month}&year=${year}`,
      {}
    );

    if (!res.ok) {
      const text = await res.text();
      console.error("Download failed:", text);
      return;
    }

    const contentType = res.headers.get("content-type");
    if (!contentType?.includes("spreadsheet")) {
      console.error("Invalid file type:", contentType);
      return;
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "pf_submission.xlsx";
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error downloading report:", err);
  }

  }
  
  const actionMenu = () => {
    return (
      <Menu
        anchorEl={showActionMenu}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={Boolean(showActionMenu)}
        onClose={handleCloseMenuItems}
        sx={{ mt: 2 }}
      >
        <a href={`${domain}/api/v1/payrole/generate-salary-csv?org_id=${loggedUser?.org_id}&month=${rowData?.original?.month}&year=${rowData?.original?.year}`}>
          <NotificationItem icon={<Icon>download</Icon>} title="Download Bank Sheet" />
        </a>
        {/* <a href={`https://api.flickhr.com/api/v1/payrole/pf-submission.xlsx?org_id=${loggedUser?.org_id}&month=${rowData?.original?.month}&year=${rowData?.original?.year}`}> */}
          <NotificationItem onClick={() => {handlePFSheetDownload(rowData?.original?.month, rowData?.original?.year)}} icon={<Icon>download</Icon>} title="Download PF Sheet" />
        {/* </a> */}
      </Menu>
    );
  };

  async function getSalaryBatches() {
    try {
      const res = await ApiCalls.getSalaryBatch();
	      if (res.success && res.code === 200) {
	        const rows = res.data.map((batch) => ({
	          batch: monthToNumber[batch.month],
	          year: batch.year,
	          month: batch.month,
	          id : batch.id,
	          is_published: batch.is_published,
	        }));
	        setBatch((prev) => ({ ...prev, rows }));
	      }
    } catch (err) {
      console.error("Error fetching salary batches", err);
    }
  }

  const handleDownloadYearlySalaryReport = async () => {
  try {
    const res = await authFetch(
      `https://www.flickhr.com/api/v1/payrole/salary-by-employee.xlsx?from=2025-03&to=2026-01`,
      {}
    );

    if (!res.ok) {
      const text = await res.text();
      console.error("Download failed:", text);
      return;
    }

    const contentType = res.headers.get("content-type");
    if (!contentType?.includes("spreadsheet")) {
      console.error("Invalid file type:", contentType);
      return;
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "salary-slip.pdf";
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Error downloading report:", err);
  }
};

	const handleSalaryGenerate = async () => {

		const payload = {
			year: generateSalaryData.year,
			contract_ids : generateSalaryData.contract_ids.map(emp => emp.id),
			month: generateSalaryData.month,
			org_id: loggedUser?.org_id,
			dry_run: generateSalaryData.dry_run
		}
		const response = await ApiCalls.generatePayroll(payload);
		if (response?.success) {
			setGenerateSalaryDialog(false);
			getSalaryBatches();
		}

	}

  return (
    <div>
      <Card>
        <MDBox p={2} style={{display : "flex", justifyContent:"space-between"}}>
          <MDTypography variant="h4">Salary Batches</MDTypography>
          <div>
          <MDButton variant = 'gradient' color = 'dark' onClick = {() => setGenerateSalaryDialog(true)}>Generate Salary</MDButton>
          <IconButton onClick={() => handleDownloadYearlySalaryReport()}><Download/></IconButton>
          </div>
        </MDBox>
        <MDBox>
          <DataTable table={batch}></DataTable>
          <Dialog
            PaperProps={{
              sx: dialogPaperSx,
            }}
            open={generateSalaryDialog}
            onClose={() => setGenerateSalaryDialog(false)}
          >
            <DialogTitle
              sx={{
                width: "100%",
                p: "20px",
                background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
                color: "white",
              }}
            >
              <Typography sx={{ color: "white", fontWeight: "Medium" }}>
                Generate Salary
              </Typography>
            </DialogTitle>
            <DialogContent
              sx={{
                p: "4px",
                width: "100%",
                backgroundColor: darkMode ? palette.background.muted : colors.white.main,
              }}
            >
              <MDBox align="center" p={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>

                    {/*<FormField
                      label="Select Year"
                      value={generateSalaryDialog.start_date}
                      onChange={(e) => {
                        setGenerateSalaryData((prev) => ({
                          ...prev,
                          year : e.target.value,
                        }));
                      }}
                      inputProps={{ type: "year" }}
                      placeholder="Select Year"
                    />*/}
                    <div style={{ height: "20px" }}></div>
                    <FormField
                      label="Select Month"
                      value={generateSalaryDialog.month}
											//onChange={(e) => {
											//	const monthValue = e.target.value; // "2025-12"
											//	const month = monthValue.split("-")[1]; // "12"

											//	setGenerateSalaryData((prev) => ({
											//		...prev,
											//		month: month,
											//	}));
                      //}}
											onChange={(e) => {
												const value = e.target.value; // "2025-12"

												const [year, month] = value.split("-"); // ["2025", "12"]

												setGenerateSalaryData((prev) => ({
													...prev,
													year: year,     // ✅ "2025" (NOT "25")
													month: month,   // "12"
												}));
											}}
                      inputProps={{ type: "month" }}
                      placeholder="Select Month"
                    />
                    <Autocomplete
                      multiple
                      options={employeeList}
                      value={generateSalaryData.contract_ids ?? []} 
                      getOptionLabel={(option) =>
                        `${option.user.firstname} ${option.user.lastname}`
                      }
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      onChange={(event, selectedEmployees) => {
                        setGenerateSalaryData((prev) => ({
                          ...prev,
                          contract_ids: selectedEmployees ?? [],     
                        }));
                      }}
                      renderInput={(params) => (
                        <FormField {...params} label="Select Employees" />
                      )}
                    />

                    {/*<FormControlLabel
                      control={
                        <Checkbox
                          // checked={generateSalaryData?.dry_run}
                          checked={true}
                          onChange={(e) => {
                            setGenerateSalaryData((prev) => ({
                              ...prev,
                              dry_run: e.target.checked,
                            }));
                          }}
                        />
                      }
                      label="PF Applicable"
                    />*/}
                  </Grid>
    
                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                    <MDButton
                      variant="outlined"
                      color="secondary"
                      onClick={() => setGenerateSalaryDialog(false)}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        handleSalaryGenerate()
                        setGenerateSalaryDialog(false);
                      }}
                    >
                      Generate
                    </MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </DialogContent>
          </Dialog>
        </MDBox>
        {actionMenu()}
      </Card>
    </div>
  );
}
